import * as types from './types';

function multiSelect(state = {}, action){

  switch (action.type) {
    case types.ON_TOGGLE_ROW:
    let rows = []
    rows = rows.concat(state.rows)

    const index = rows.indexOf(action.uid)
    if(index > -1) {
      rows.splice(index, 1)
    } else {
      rows.push(action.uid)
    }

    return {
      active: state.active,
      rows: [
        ...rows
      ]
    }

    case types.ON_MULTISELECT_TOGGLE:
    return {
      active: state.active!=null?!(state.active):true,
      rows: []
    }

    case types.ON_SELECTION_CLEAR:
    return {
      active: true,
      rows: []
    }

    default:
    return state
  }
}

export default function multiSelects(state = {}, action){
  const { name } = action
  if(name != null) {
    return {...state, [name]: multiSelect(state[name], action)}
  }
  else {
    return state
  }
}
